module.exports = __webpack_public_path__ + "2d0d27d78c465979f8497ef33dbe9145.svg";